import Solution from 'Components/Solutions/components/Solution/Solution';

export default Solution;
